module.exports = __webpack_public_path__ + "static/media/health4.bb77f3d4.svg";